import fetch from '@/utils/fetch'

// 获取到openid
export function GetOpenId (query) {
  return fetch({
    url: 'api/openid',
    method: 'get',
    params: query
  })
}

// 验证openid
export function getaccountInfo (query) {
  return fetch({
    url: 'safeStudy/login/wxCheckOpenid',
    method: 'get',
    params: query
  })
}
// 获取验证码
export function GetSmsCode (query) {
  return fetch({
    url: 'safeStudy/login/message',
    method: 'get',
    params: query
  })
}
// GET /safeStudy/login/verification
// 登录
export function ToLogin (query) {
  return fetch({
    url: 'safeStudy/login/verification',
    method: 'get',
    params: query
  })
}
// 解绑
export function cleanOpenid (query) {
  return fetch({
    url: '/safeStudy/login/cleanOpenid',
    method: 'get',
    params: query
  })
}
// 获取首页未读消息数
export function getUnreadNotes (query) {
  return fetch({
    url: 'safeStudy/noticeState/unreadcCount',
    method: 'get',
    params: query
  })
}

// 获取首页学习进度
export function getMonthProgress (query) {
  return fetch({
    url: 'safeStudy/studyPlanSummary/IndexInfo',
    method: 'get',
    params: query
  })
}
// 所有参数相关
export function getAllConfigs (query) {
  return fetch({
    url: 'params/getParams',
    method: 'get',
    params: query
  })
}

// 获取个人信息
export function getuserinfo (query) {
  return fetch({
    url: 'safeStudy/employeeInfo/employeeInfomation',
    method: 'get',
    params: query
  })
}

// 获取缴费记录
export function payActives (query) {
  return fetch({
    url: 'safeStudy/paymentRecord/paymentRecords',
    method: 'get',
    params: query
  })
}

// 获取费用使用记录
export function activateDetails (query) {
  return fetch({
    url: 'safeStudy/payActivateDetail/activateDetails',
    method: 'get',
    params: query
  })
}

// 获取培训年计划列表
export function studyYearPlan (query) {
  return fetch({
    url: 'safeStudy/studyPlan/studyPlans',
    method: 'get',
    params: query
  })
}

// 获取登录学员的对应有培训记录的年份
export function studyYears (query) {
  return fetch({
    url: 'safeStudy/studyYearPlan/studyYearPlans',
    method: 'get',
    params: query
  })
}

// 获取登录学员选定年对应的有培训记录的月份
export function studyMonths (query) {
  return fetch({
    url: 'safeStudy/studyYearPlan/studyMonths',
    method: 'get',
    params: query
  })
}

// 获取学习记录列表
export function videoPlNotes (query) {
  return fetch({
    url: 'safeStudy/courseware/coursewares',
    method: 'get',
    params: query
  })
}
// 是否缴费
export function isPayFee (query) {
  return fetch({
    url: 'safeStudy/api/money',
    method: 'get',
    params: query
  })
}
// 判断是否本年度有合格的考试
export function isPass (query) {
  return fetch({
    url: 'tbQuestionExam/checkPassExam',
    method: 'get',
    params: query
  })
}
//  获取上传图片大小
export function uploadImgSize () {
  return fetch({
    url: 'safeStudy/api/imageSize',
    method: 'get'
  })
}
// 获取拍照时间间隔
export function snapTimeInterval () {
  return fetch({
    url: 'safeStudy/api/snapTimeInterval',
    method: 'get'
  })
}
// 获取断点插入时间间隔
export function videoTimeInterval () {
  return fetch({
    url: 'safeStudy/api/videoTimeInterval',
    method: 'get'
  })
}
// 是否达到计划学时
export function summaryStatus (query) {
  return fetch({
    url: 'safeStudy/studyPlanSummary/summaryStatus',
    method: 'get',
    params: query
  })
}
// 上传学时照片
export function uploadJPG (query) {
  return fetch({
    url: 'safeStudy/check/UploadJPG',
    method: 'get',
    params: query
  })
}
// 上传学时
export function uploadStudyTime (query) {
  return fetch({
    url: 'GetDataService/SetVideoTimer',
    method: 'post',
    params: query
  })
}
// 视频播放记录保存
export function SaveVideoPlayNotesDetail (query) {
  return fetch({
    url: 'GetDataService/SaveVideoPlayNotesDetail',
    method: 'post',
    params: query
  })
}
// 从首页获取学习记录列表
export function videoPlNotesHome (query) {
  return fetch({
    url: 'safeStudy/courseware/monthCoursewares',
    method: 'get',
    params: query
  })
}
// 获取学习照片
export function photoLists (query) {
  return fetch({
    url: 'safeStudy/check/checks',
    method: 'get',
    params: query
  })
}

// 获取公告列表
export function noticeLists (query) {
  return fetch({
    url: 'safeStudy/sysNotice/sysNotices',
    method: 'get',
    params: query
  })
}
// 获取公告详情
export function noticeDetail (query) {
  return fetch({
    url: 'safeStudy/sysNotice/sysNotice',
    method: 'get',
    params: query
  })
}
// 获取消息列表
export function messageLists (query) {
  return fetch({
    url: 'safeStudy/pushMessage/pushMessages',
    method: 'get',
    params: query
  })
}
// 获取消息详情
export function messageDetail (query) {
  return fetch({
    url: 'safeStudy/pushMessage/pushMessage',
    method: 'get',
    params: query
  })
}
// 标记已读
export function setStatus (query) {
  return fetch({
    url: 'safeStudy/noticeState/noticeStatus',
    method: 'get',
    params: query
  })
}
// 考试配置
export function getTestConfigs (query) {
  return fetch({
    url: 'safeStudy/api/getExamConfig',
    method: 'get',
    params: query
  })
}
// 获取考题
export function getTestInfos (query) {
  return fetch({
    url: 'safeStudy/question/getquestion/'+query.studyplanid+"/"+query.stuId,
    // url: 'safeStudy/question/getquestion/'+query.studyplanid,
    method: 'get',
    params: {}
  })
}
// 提交考试
export function saveTestInfos (query) {
  return fetch({
    url: 'tbQuestionExam/submitExam',
    method: 'post',
    params: query
  })
}
// 获取jsapi相关配置的接口
export function getConfig (query) {
  return fetch({
    url: 'wxpay/wxpayConf',
    method: 'post',
    params: query
  })
}
// 公众号发起订单
export function sendOrder (query) {
  return fetch({
    url: 'wxpay/orderp',
    method: 'post',
    params: query
  })
}

// 订单确认 POST /order/view
export function sureOrder (query) {
  return fetch({
    url: 'order/view',
    method: 'post',
    params: query
  })
}
// 课程
export function getPublicCourseware (query) {
  return fetch({
    url: 'GetDataService/getPublicCourseware',
    method: 'get',
    params: query
  })
}

// 培训页
export function getTrainlist (query) {
  
  return fetch({
    url: 'GetDataService/train/list',
    method: 'get',
    params: query
  })
}

// 培训页
export function getTrainlistAqxx (query) {
  
  return fetch({
    url: 'GetDataService/aqxx/list',
    method: 'get',
    params: query
  })
}



// 考核页
export function getExamlist (query) {
  return fetch({
    url: 'GetDataService/check/list',
    method: 'get',
    params: query
  })
}

// 课件列表
export function getStudyMonthToCourseware (query) {
  return fetch({
    url: 'safeStudy/courseware/monthCoursewares',
    method: 'get',
    params: query
  })
}
// 获取随堂测试题目
export function getTrainTest (query) {
  return fetch({
    url: 'GetDataService/getExamByVideoId',
    method: 'get',
    params: query
  })
}

// 获取课程文件夹
export function getCoursewareFolder (query) {
  return fetch({
    url: 'GetDataService/getCoursewareFolder',
    method: 'get',
    params: query
  })
}

// 获取订单列表
export function getOrderList (query) {
  return fetch({
    url: 'order/list',
    method: 'POST',
    params: query
  })
}

// 获取首页安全学习列表
export function getAqxxVideo (query) {
  return fetch({
    url: 'GetDataService/getAqxxVideo',
    method: 'get',
    params: query
  })
}

// 是否需要完善信息
export function needws (query) {
  return fetch({
    url: 'user/needws',
    method: 'get',
    params: query
  })
}

// 企业列表
export function companyList (query) {
  return fetch({
    url: 'company/list',
    method: 'get',
    params: query
  })
}

// 完善信息
export function perfect (query) {
  return fetch({
    url: 'user/perfect',
    method: 'post',
    params: query
  })
}

// 获取省份
export function getProvince (query) {
  return fetch({
    url: 'data/province',
    method: 'get',
    params: query
  })
}

// 获取城市
export function getCity (query) {
  return fetch({
    url: 'data/city',
    method: 'get',
    params: query
  })
}


// 获取发证机关
export function getOrgan (query) {
  return fetch({
    url: 'data/organ',
    method: 'get',
    params: query
  })
}

// 获取企业
export function getCompany (query) {
  return fetch({
    url: 'data/company',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/Api.js